class HydrantBundleWrapper extends HTMLElement {
	constructor() {
		super()
		this.submitButton = this.querySelector("button[type='submit']")
		this.form = this.querySelector("#hydrant-bundle-form")
		this.addToCartBtn = this.querySelector("#add-bundle-tocart")
		this.previewSlots = this.querySelectorAll(".bundle-product-preview")
		this.cartProducts = []
		this.formObject = {
			"bundle-size": 2,
			products: [],
		}
		this.submitButton.disabled = true
	}

	connectedCallback() {
		console.log("component is connected")
		this.addToCartBtn.addEventListener("click", async () => {
			console.log("Add to cart")
			if (this.formObject.products.length < 2) return

			for (let index = 0; index < this.formObject.products.length; index++) {
				await fetch("/cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						id: this.formObject.products[index].id,
						qty: 1,
					}),
				})
			}

			if (this.formObject["bundle-size"] === 2) {
				await fetch("/discount/BUNDLES15")
			} else if (this.formObject["bundle-size"] === 3) {
				await fetch("/discount/BUNDLES20")
			}

			Rebuy.SmartCart.show()
			//Reset the builder.

			this.resetBuilder()
		})

		this.querySelectorAll(".variant-action-add-to-bundle").forEach(button => {
			button.addEventListener("click", $event => {
				$event.preventDefault()
				const id = Number($event.currentTarget.getAttribute("data-id"))
				const _product = window.bundleVariants.filter(item => item.id === id).length > 0 ? window.bundleVariants.filter(item => item.id === id)[0] : undefined

				if (Number(this.formObject?.products?.length) < this.formObject["bundle-size"]) {
					this.formObject?.products.push(_product)

					if (this.formObject?.products.length >= this.formObject["bundle-size"]) {
						//If the limit is reached disable adding more products
						this.querySelectorAll(".variant-action-add-to-bundle").forEach(element => {
							element.disabled = true
						})
					} else {
						//If the limit is reached disable adding more products
						this.querySelectorAll(".variant-action-add-to-bundle").forEach(element => {
							element.disabled = false
						})
					}
				}

				this.form.dispatchEvent(new Event("change"))
			})
		})

		this.form.addEventListener("change", $event => {
			console.log("form change...")

			let totalPrice = 0.0
			const formData = new FormData(this.form)
			formData.forEach((value, key) => {
				this.formObject[key] = parseInt(value)
			})

			if (this.formObject["bundle-size"] > 2) {
				this.querySelector(".bundle-product-preview:last-of-type").classList.remove("hidden")
				this.querySelector(".bundle-size-sub-two").classList.add("hidden")
				this.querySelector(".bundle-size-sub-three").classList.remove("hidden")
				// this.querySelector(".bundle-price-sub-two").classList.add("hidden")
				// this.querySelector(".bundle-price-sub-three").classList.remove("hidden")
			} else {
				this.querySelector(".bundle-product-preview:last-of-type").classList.add("hidden")
				this.querySelector(".bundle-size-sub-two").classList.remove("hidden")
				this.querySelector(".bundle-size-sub-three").classList.add("hidden")
				// this.querySelector(".bundle-price-sub-two").classList.remove("hidden")
				// this.querySelector(".bundle-price-sub-three").classList.add("hidden")
			}

			//Refresh the products buttons.
			if (this.formObject?.products.length >= this.formObject["bundle-size"]) {
				//If the limit is reached disable adding more products
				this.querySelectorAll(".variant-action-add-to-bundle").forEach(element => {
					element.disabled = true
				})
			} else {
				//If the limit is reached disable adding more products
				this.querySelectorAll(".variant-action-add-to-bundle").forEach(element => {
					element.disabled = false
				})
			}

			//Its absolutely necessary to make sure that product at slot 3 is remove if the customer is switching from 3 packs to 2 packs.
			if (this.formObject["bundle-size"] < 3) {
				delete this.formObject.products[2]
				this.formObject.products = this.formObject.products.filter(t => t)
				//Refresh all the slots.
				this.previewSlots.forEach(slot => slot.replaceChildren())
			}

			//Render products in the bundle.
			this.formObject.products.forEach((product, index) => {
				console.log(index)
				const removeButton = document.createElement("button")
				removeButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.8841 4.11599C20.3722 4.60415 20.3722 5.39561 19.8841 5.88376L5.88407 19.8838C5.39591 20.3719 4.60445 20.3719 4.1163 19.8838C3.62814 19.3956 3.62814 18.6041 4.1163 18.116L18.1163 4.11599C18.6045 3.62784 19.3959 3.62784 19.8841 4.11599Z"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M4.1163 4.11599C4.60445 3.62784 5.39591 3.62784 5.88407 4.11599L19.8841 18.116C20.3722 18.6041 20.3722 19.3956 19.8841 19.8838C19.3959 20.3719 18.6045 20.3719 18.1163 19.8838L4.1163 5.88376C3.62814 5.39561 3.62814 4.60415 4.1163 4.11599Z"/></svg>`
				removeButton.classList.add("absolute", "bg-white", "-right-1.5", "rounded-full", "text-black", "-top-1.5", "w-5", "p-1")
				removeButton.addEventListener("click", () => {
					delete this.formObject.products[index]
					this.formObject.products = this.formObject.products.filter(t => t)
					this.previewSlots[index].replaceChildren()

					//Refresh all the slots.
					this.previewSlots.forEach(slot => slot.replaceChildren())

					this.form.dispatchEvent(new Event("change"))
				})

				const image = document.createElement("img")
				image.src = product.variant_picture
				image.classList.add("bg-white", "rounded-lg")

				this.previewSlots[index].replaceChildren()
				this.previewSlots[index].appendChild(image)
				this.previewSlots[index].appendChild(removeButton)
			})

			//This will toggle on and off the add to cart button depending on the products stored in the object and the package size
			this.submitButton.disabled = !(this.formObject.products.length === this.formObject["bundle-size"])

			//Get the total price from the products and add it to the submit button
			//If 3 pack size then the price will be 20% off else it's 15%
			if (this.formObject.products.map(item => item.price * item.quantity).length) {
				totalPrice = this.formObject.products.map(item => item.price).reduce((a, b) => a + b)

				if (this.formObject["bundle-size"] === 3) {
					totalPrice = totalPrice - totalPrice * (20 / 100)
				} else if (this.formObject["bundle-size"] === 2) {
					totalPrice = totalPrice - totalPrice * (15 / 100)
				}
			}

			this.querySelector("#add-bundle-tocart .add-bundle-tocart-price-total").innerText = totalPrice > 0 ? Shopify.formatMoney(totalPrice) : "$0.00"

			console.log(totalPrice)
		})

		this.form.addEventListener("submit", async $event => {
			$event.preventDefault()
		})

		this.resetBuilder = () => {
			this.formObject.products = []

			//Refresh all the slots.
			this.previewSlots.forEach(slot => slot.replaceChildren())
		}
	}
}

class HydrantBundle extends HTMLElement {
	constructor() {
		super()
		this.sizePreview = this.querySelector(".size-preview")
		this.form = this.querySelector("#hydrant-bundle-form")
		this.submitButton = this.querySelector("button[type='submit']")
		this.formObject = {}
		this.cartProducts = []
		this.pevFormObject = {
			packsize: 2,
		}
		this.quantityInputs = this.querySelectorAll("hydrant-quantity")

		this.submitButton.disabled = true

		//For some reason the form isn't picking up on the qty changes.
		this.quantityInputs.forEach(item => {
			item.querySelector('input[type="number"]').addEventListener("change", $event => {
				this.form.dispatchEvent(new Event("change"))
			})
		})
	}

	resetBuilder() {
		console.warn("Reset builder")
		this.quantityInputs.forEach(item => {
			item.querySelector('input[type="number"]').value = 0
		})
		for (let index = 0; index < 3; index++) this.querySelector(`div[data-id='pack-${index + 1}']`).style.background = "" // reset backgrounds
		this.querySelector(".subscription-button-information .total").innerText = "$0.00" //Reset price
		this.formObject = {
			packsize: this.formObject.packsize,
		} //reset form object
		this.cartProducts = [] //reset the cart products object
	}

	//Check each item width. and based on the item width we gonna offset the parent by that.
	//Make sure to store

	connectedCallback() {
		this.form.addEventListener("change", $event => {
			const formData = new FormData(this.form)
			formData.forEach((value, key) => {
				this.formObject[key] = parseInt(value)
			})

			const totalQuantity = Object.entries(this.formObject)
				.filter(([key]) => key.startsWith("quantity"))
				.reduce((acc, [_, value]) => acc + value, 0)

			//Based on the pack size disable and enable the quantity inputs
			if (totalQuantity >= this.formObject.packsize) {
				//Disable all the quantity fields.
				this.quantityInputs.forEach(item => {
					item.querySelector(".add-more").disabled = true
				})
			} else {
				//Re-enable all quantity fields.
				this.quantityInputs.forEach(item => {
					item.querySelector(".add-more").disabled = false
				})
			}

			//If the packsize changes reset all the quantity inputs.
			if (this.pevFormObject.packsize && this.pevFormObject.packsize != this.formObject.packsize) {
				this.resetBuilder()
			}

			//Toggle the submit button availability.
			this.submitButton.disabled = totalQuantity !== this.formObject.packsize

			if (this.formObject.packsize > 2) {
				this.sizePreview.classList.add("active")
			} else {
				this.sizePreview.classList.remove("active")
			}

			//Keep a copy of previous values.
			formData.forEach((value, key) => {
				this.pevFormObject[key] = parseInt(value)
			})

			//Get the products selected.
			const _products = Object.entries(this.formObject)
				.filter(([key, value]) => key.startsWith("quantity") && value > 0)
				.map(([key, value]) => {
					const id = key.match(/quantity\[(\d+)]\[(\d+)\]/)[2]
					return {quantity: parseInt(value), id: parseInt(id)}
				})

			const products = _products.map(item => {
				const variant = window.bundleVariants.filter(variant => variant.id === item.id)[0]
				variant.quantity = item.quantity
				return variant
			})

			let totalPrice = 0.0

			//Get the total price from the products and add it to the submit button
			//If 3 pack size then the price will be 20% off else it's 15%
			if (products.map(item => item.price * item.quantity).length) {
				totalPrice = products.map(item => item.price * item.quantity).reduce((a, b) => a + b)
				if (this.formObject.packsize === 3) {
					totalPrice = totalPrice - totalPrice * (20 / 100)
				} else if (this.formObject.packsize === 2) {
					totalPrice = totalPrice - totalPrice * (15 / 100)
				}
			}

			this.querySelector(".subscription-button-information .total").innerText = totalPrice > 0 ? Shopify.formatMoney(totalPrice) : "$0.00"
			for (let index = 0; index < 3; index++) this.querySelector(`div[data-id='pack-${index + 1}']`).style.background = "" // reset backgrounds
			let productIndex = 0
			products.forEach((item, index) => {
				for (let i = 0; i < item.quantity; i++) {
					productIndex = productIndex + 1
					this.querySelector(`div[data-id='pack-${productIndex}']`).style.background = `linear-gradient(45deg, ${item.metafields.colours.primary_colour} 0%, ${item.metafields.colours.secondary_colour} 100%)`
				}
			})

			this.cartProducts = products
		})

		this.form.addEventListener("submit", async $event => {
			$event.preventDefault()

			const products = this.cartProducts
			for (let index = 0; index < products.length; index++) {
				await fetch("/cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						id: products[index].id,
						qty: products[index].quantity,
					}),
				})

				console.log({
					id: products[index].id,
					qty: products[index].quantity,
				})
			}

			if (this.formObject.packsize === 2) {
				await fetch("/discount/BUNDLES15")
			} else if (this.formObject.packsize === 3) {
				await fetch("/discount/BUNDLES20")
			}

			Rebuy.SmartCart.show()
			this.resetBuilder()

			return
		})
	}
}

customElements.define("hydrant-bundle", HydrantBundle)
customElements.define("hydrant-bundle-wrapper", HydrantBundleWrapper)
